var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNodes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.828125,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#2F4858"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_6785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5646 18.0884H18.9146V22.7384C18.9146 23.2499 18.4961 23.6684 17.9846 23.6684C17.4731 23.6684 17.0546 23.2499 17.0546 22.7384V18.0884H12.4046C11.8931 18.0884 11.4746 17.6699 11.4746 17.1584C11.4746 16.6469 11.8931 16.2284 12.4046 16.2284H17.0546V11.5784C17.0546 11.0669 17.4731 10.6484 17.9846 10.6484C18.4961 10.6484 18.9146 11.0669 18.9146 11.5784V16.2284H23.5646C24.0761 16.2284 24.4946 16.6469 24.4946 17.1584C24.4946 17.6699 24.0761 18.0884 23.5646 18.0884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_6785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.32,
    height: 22.32,
    fill: "white",
    transform: "translate(6.82812 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNodes);
export default __webpack_public_path__ + "static/media/addNodes.687e2975d025401cd7b146526d911d5e.svg";
export { ForwardRef as ReactComponent };